/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Taunusgymnasium1Inputs */

const en__field_enum_taunusgymnasium1 = /** @type {(inputs: _Field_Enum_Taunusgymnasium1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Königstein`)
};

const de__field_enum_taunusgymnasium1 = /** @type {(inputs: _Field_Enum_Taunusgymnasium1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taunusgymnasium`)
};

/**
* | output |
* | --- |
* | "Königstein" |
*
* @param {_Field_Enum_Taunusgymnasium1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_taunusgymnasium1 = /** @type {((inputs?: _Field_Enum_Taunusgymnasium1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Taunusgymnasium1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_taunusgymnasium1(inputs)
	return de__field_enum_taunusgymnasium1(inputs)
});
export { _field_enum_taunusgymnasium1 as "_field_enum_Taunusgymnasium" }